module.exports = __webpack_public_path__ + "img/spicy-chicken-pitta-pockets.02c4530e.jpg";